<template>
  <div class="user-protocol-container" v-loading="loadingData">
    <div class="protocol-card">
      <div class="user-protocol-title">用户协议</div>
      <div class="user-protocol-content" v-html="protocolContent" />
    </div>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      protocolContent: "",
      loadingData: true
    };
  },
  created: function() {
    // 查询用户协议
    this.loadProtocolData();
  },
  methods: {
    async loadProtocolData() {
      const res = await httpRequest("/app/setting/protocol", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.protocolContent = res.data;
      }
      this.loadingData = false;
    }
  }
};
</script>

<style scoped lang="scss">
.user-protocol-container {
  width: 1200px;
  max-width: calc(100% - 40px);
  margin: 30px auto 40px;
  
  .protocol-card {
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
    padding: 60px 80px;

    .user-protocol-title {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1e293b;
      text-align: center;
      margin-bottom: 40px;
      position: relative;
      
      &::after {
        content: '';
        display: block;
        width: 60px;
        height: 4px;
        background: #00b0ab;
        border-radius: 2px;
        margin: 16px auto 0;
      }
    }

    .user-protocol-content {
      min-height: 500px;
      text-align: left;
      font-size: 15px;
      line-height: 2.2;
      color: #334155;
      
      ::v-deep p {
        margin-bottom: 16px;
        text-align: justify;
      }
      
      ::v-deep strong, ::v-deep b {
        color: #0f172a;
        font-weight: 600;
      }
    }
  }
}
</style>
